 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import ALSOBYJEANSASSON from '@/components/alsobyjeansasson'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import AUTHORSNOTE from '@/components/authorsnote'
 import CONTENTS from '@/components/contents'
 import ANOTEFROMJEANSASSON from '@/components/anotefromjeansasson'
 import PROLOGUE from '@/components/prologue'
 import CHAPTERONE from '@/components/chapterone'
 import CHAPTERTWO from '@/components/chaptertwo'
 import CHAPTERTHREE from '@/components/chapterthree'
 import CHAPTERFOUR from '@/components/chapterfour'
 import CHAPTERFIVE from '@/components/chapterfive'
 import CHAPTERSIX from '@/components/chaptersix'
 import CHAPTERSEVEN from '@/components/chapterseven'
 import CHAPTEREIGHT from '@/components/chaptereight'
 import CHAPTERNINE from '@/components/chapternine'
 import CHAPTERTEN from '@/components/chapterten'
 import CHAPTERELEVEN from '@/components/chaptereleven'
 import CHAPTERTWELVE from '@/components/chaptertwelve'
 import EPILOGUE from '@/components/epilogue'
 import ALLABOUTJEANSASSON from '@/components/allaboutjeansasson'
 import EXCERPTFROMPRINCESSSULTANASCIRCLE from '@/components/excerptfromprincesssultanascircle'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/anotefromjeansasson",
 			"name" : "anotefromjeansasson",
 			"component" : ANOTEFROMJEANSASSON
 		},
 		{
 			"path" : "/prologue",
 			"name" : "prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/chapterone",
 			"name" : "chapterone",
 			"component" : CHAPTERONE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js